<script>
const intervalTimeMs = 5000;

export default {
  name: 'RenewData',

  data() {
    return {
      requestIntervalID: null,
    };
  },

  mounted() {
    this.requestIntervalID = setInterval(() => {
      this.fetchRegistrationData(this.$route.params.id);
    }, intervalTimeMs);
  },

  beforeDestroy() {
    clearInterval(this.requestIntervalID);
  },

  methods: {
    ...mapActions('tournamentRegistration', [
      'fetchRegistrationData',
    ]),
  },
};
</script>
